export const es: Record<string, string> = {
  "dashboard.title": "Segmentación",
  "dashboard.pageDescription": "Programación de viviendas y conglomerados por sede y evolución mensual nacional.",
  "dashboard.bySite": "Por sede",
  "dashboard.national": "Evolución nacional",
  "dashboard.updating": "Actualizando…",
  "dashboard.scope": "Ámbito de segmentación",
  "dashboard.loadError": "No se pudo cargar la programación.",
  "dashboard.exportError": "No se pudo exportar la programación.",
  "dashboard.updateError": "No se pudo actualizar la programación",
  "dashboard.retainedData": "Se mantienen los datos de la última consulta.",
  "dashboard.loadingLabel": "Cargando dashboard de segmentación",
  "dashboard.loading": "Cargando dashboard de segmentación…",
  "dashboard.summaryLabel": "Resumen de programación de las sedes registradas",
  "dashboard.registeredSites": "Sedes registradas",
  "dashboard.showAll": "Mostrar todas las sedes",
  "dashboard.viewExcess": "Consultar excedentes",
  "dashboard.noExcess": "Sin excedentes registrados",
  "dashboard.missingMetric": "Al menos una métrica sin detalle mensual",
  "dashboard.ringNote": "Los gráficos muestran la meta cubierta por sede. La programación total incluye excedentes.",
  "dashboard.siteSchedule": "Programación por sede",
  "dashboard.compareDescription": "Compara el avance y consulta su distribución mensual.",
  "dashboard.scheduleView": "Vista de programación",
  "dashboard.chart": "Gráfico",
  "dashboard.table": "Tabla",
  "dashboard.restore": "Restaurar vista",
  "dashboard.expand": "Ampliar vista",
  "dashboard.searchSite": "Buscar sede",
  "dashboard.sitePlaceholder": "Nombre de la sede",
  "dashboard.clearSearch": "Limpiar búsqueda",
  "dashboard.status": "Estado",
  "dashboard.allSites": "Todas las sedes",
  "dashboard.withPending": "Con pendientes",
  "dashboard.withExcess": "Con excedentes",
  "dashboard.withoutMonthly": "Sin desglose mensual",
  "dashboard.sortBy": "Ordenar por",
  "dashboard.sortSite": "Sede · A a Z",
  "dashboard.sortHousingAsc": "Viviendas · menor avance",
  "dashboard.sortHousingDesc": "Viviendas · mayor avance",
  "dashboard.sortClustersAsc": "Conglomerados · menor avance",
  "dashboard.sortClustersDesc": "Conglomerados · mayor avance",
  "dashboard.clearFilters": "Limpiar filtros",
  "dashboard.noSites": "No se encontraron sedes",
  "dashboard.noSchedule": "Sin programación registrada",
  "dashboard.changeFilters": "Prueba otro nombre o cambia el filtro de estado.",
  "dashboard.selectProgress": "Selecciona un avance para ver el detalle mensual.",
  "dashboard.selectValue": "Selecciona un valor de avance para ver el detalle.",
  "dashboard.excessNote": "Un avance mayor al 100 % indica programación sobre la meta. Los pendientes y excedentes se suman por sede, sin compensarse entre sí.",
  "dashboard.housing": "Viviendas",
  "dashboard.clusters": "Conglomerados",
  "dashboard.housingLower": "viviendas",
  "dashboard.clustersLower": "conglomerados",
  "dashboard.scheduledHousing": "Viviendas programadas",
  "dashboard.scheduledClusters": "Conglomerados programados",
  "dashboard.annualBySite": "Programación anual por sede",
  "dashboard.ofTarget": " de la meta",
  "dashboard.covered": "Meta cubierta",
  "dashboard.uncovered": "Por cubrir",
  "dashboard.annualTarget": "Meta anual",
  "dashboard.pending": "Pendientes",
  "dashboard.pendingLower": "pendientes",
  "dashboard.pendingSingle": "Pendiente",
  "dashboard.excess": "Excedente",
  "dashboard.donutPending": "Por cubrir: {value} ({percentage}).",
  "dashboard.site": "Sede operativa",
  "dashboard.scheduledTarget": "Programadas / meta",
  "dashboard.scheduledTargetOther": "Programados / meta",
  "dashboard.siteProgress": "Avance de programación por sede",
  "dashboard.noTargetDefined": "Sin meta definida",
  "dashboard.noTarget": "Sin meta",
  "dashboard.exceeds": "Supera la meta",
  "dashboard.viewMonths": "Ver meses",
  "dashboard.targetUndefined": "Meta no definida",
  "dashboard.siteTable": "Tabla de programación por sede",
  "dashboard.siteTableCaption": "Programación de viviendas y conglomerados por sede. Los enlaces de avance abren el detalle mensual.",
  "dashboard.target": "Meta",
  "dashboard.progress": "Avance",
  "dashboard.pendingExcess": "Pendiente / excedente",
  "dashboard.pendingExcessShort": "Pend. / exced.",
  "dashboard.selectionSubtotal": "Subtotal de la selección",
  "dashboard.siteTotal": "Total de sedes",
  "dashboard.prioritize": "Priorizar la revisión de sedes",
  "dashboard.largestPending": "Mayores pendientes anuales",
  "dashboard.priorityNote": "Compara el volumen pendiente de programación. Estos valores anuales no indican por sí solos un retraso.",
  "dashboard.sampleType": "Tipo de muestra",
  "dashboard.noPending": "No hay pendientes registrados para esta métrica.",
  "dashboard.chartRegion": "Gráfico de programación mensual; desplazamiento horizontal disponible",
  "dashboard.monthlyChartDescription": "Los meses sin registro no se conectan. Los valores de cada mes se encuentran también en la tabla de detalle.",
  "dashboard.monthlySchedule": "Programación mensual",
  "dashboard.noRecordAvailable": "— Sin registro disponible",
  "dashboard.chartMonths": "Meses del gráfico",
  "dashboard.noRecord": "Sin registro",
  "dashboard.scheduledFeminine": "programadas",
  "dashboard.scheduledMasculine": "programados",
  "dashboard.monthKeyboard": "Selecciona un mes para fijar su detalle. Usa las flechas izquierda y derecha para recorrer los meses; Inicio y Fin llevan al primero y al último.",
  "dashboard.monthlyLoadError": "No se pudo cargar el detalle mensual.",
  "dashboard.chartImageError": "No se pudo generar la imagen del gráfico.",
  "dashboard.browserImageError": "El navegador no pudo preparar la imagen.",
  "dashboard.imageError": "No se pudo generar la imagen.",
  "dashboard.chartDownloadError": "No se pudo descargar el gráfico.",
  "dashboard.printBlocked": "Permite la ventana de impresión en el navegador y vuelve a intentarlo.",
  "dashboard.printSave": "Imprimir o guardar como PDF",
  "dashboard.schedule": "Programación",
  "dashboard.missingNotZero": "Los meses sin registro disponible no se interpretan como cero.",
  "dashboard.monthlyLoading": "Cargando detalle mensual…",
  "dashboard.annualSchedule": "Programación anual",
  "dashboard.monthlyView": "Vista del detalle mensual",
  "dashboard.queryMonth": "Mes de consulta",
  "dashboard.monthlyHint": "Selecciona un punto para consultar el mes. Los guiones indican meses sin registro; no se consideran cero.",
  "dashboard.recordedMonthTotal": "Total de meses registrados",
  "dashboard.noMonthly": "Sin detalle mensual",
  "dashboard.noMonthlyDescription": "No hay registros mensuales disponibles para esta sede y año.",
  "dashboard.annualAvailable": "El resumen anual se mantiene disponible.",
  "dashboard.preparing": "Preparando…",
  "dashboard.printPdf": "Imprimir / PDF",
  "dashboard.nationalTable": "Tabla de evolución nacional por mes; desplazamiento horizontal disponible",
  "dashboard.monthTarget": "Meta del mes",
  "dashboard.monthScheduled": "Programado del mes",
  "dashboard.cumulativeTarget": "Meta acumulada",
  "dashboard.cumulativeScheduled": "Programado acumulado",
  "dashboard.cumulativeGap": "Brecha acumulada",
  "dashboard.annualTargetPercent": "% de meta anual",
  "dashboard.nationalTableNote": "— Sin registro disponible. La brecha es la programación acumulada menos la meta acumulada; un valor negativo indica unidades por programar frente al plan.",
  "dashboard.nationalLoadError": "No se pudo cargar la evolución nacional.",
  "dashboard.nationalExportError": "No se pudo exportar la evolución nacional.",
  "dashboard.monthlyEvolution": "Evolución mensual",
  "dashboard.nationalScope": "Ámbito nacional",
  "dashboard.nationalUpdateError": "No se pudo actualizar el resumen nacional",
  "dashboard.lastQueryData": "Se muestran los datos de la última consulta.",
  "dashboard.nationalLoading": "Cargando evolución nacional…",
  "dashboard.nationalNoMonths": "No hay registros mensuales disponibles para este año. Selecciona otro año para consultar su evolución.",
  "dashboard.indicator": "Indicador",
  "dashboard.nationalIndicator": "Indicador de evolución nacional",
  "dashboard.analysisMonth": "Mes de análisis",
  "dashboard.cumulativeSchedule": "Programación acumulada",
  "dashboard.planGap": "Brecha frente al plan",
  "dashboard.gapMissing": "Faltan registros para calcularla",
  "dashboard.gapBelow": "Por programar según el plan acumulado",
  "dashboard.gapAbove": "Por encima del plan acumulado",
  "dashboard.gapReached": "Plan acumulado alcanzado",
  "dashboard.nationalView": "Vista de evolución nacional",
  "dashboard.allTwelve": "El gráfico y la tabla muestran los 12 meses.",
  "dashboard.nationalAnnual": "Resumen anual nacional registrado",
  "dashboard.reconciliation": "Conciliación de datos",
  "dashboard.viewChecks": "Consultar comprobaciones",
  "dashboard.yearProgress": "Avance acumulado durante el año",
  "dashboard.legend": "Leyenda del gráfico",
  "dashboard.nationalChart": "Gráfico interactivo de evolución nacional",
  "dashboard.nationalChartDescription": "La línea discontinua muestra el plan y la línea continua muestra la programación. Usa las flechas izquierda y derecha para explorar meses; Enter o espacio seleccionan el mes de análisis. Escape cierra la información. Los meses sin datos interrumpen la serie.",
  "dashboard.inAnalysis": "En análisis",
  "dashboard.preview": "Vista previa",
  "dashboard.gap": "Brecha",
  "dashboard.selectAnalysis": "Selecciona este mes para actualizar el análisis.",
  "dashboard.swipeMonths": "Desliza el gráfico para consultar todos los meses.",
  "dashboard.nationalKeyboard": "Selecciona un mes en el gráfico para analizarlo. Con teclado: ← → para explorar y Enter para seleccionar.",
  "dashboard.zeroNote": "La línea conserva el acumulado cuando un mes registra cero y se interrumpe cuando falta información.",
  "dashboard.noTargetLower": "sin meta definida",
  "dashboard.coverageNote": "Cobertura sin compensar excedentes",
  "dashboard.pendingSite": "Pendiente de programación por sede",
  "dashboard.operationalYear": "sedes operativas · {year}",
  "dashboard.siteExceedsOne": "{count} sede supera la meta",
  "dashboard.siteExceedsMany": "{count} sedes superan la meta",
  "dashboard.missingBreakdown": "{count} sedes con desglose pendiente",
  "dashboard.dataLoaded": "Carga de datos: {date}",
  "dashboard.siteRange": "{count} de {total} sedes",
  "dashboard.noScheduleYear": "No hay registros de programación para {year}.",
  "dashboard.registeredOne": "{count} sede registrada",
  "dashboard.registeredMany": "{count} sedes registradas",
  "dashboard.coveredBySite": "Meta cubierta de {metric} por sede",
  "dashboard.exploreCoverage": "Explorar cobertura de {metric}",
  "dashboard.detailLabel": "Ver detalle mensual de {metric} de {site}. {scheduled} programados de {target} de meta; {percentage}; {pending} pendientes{excess}.",
  "dashboard.excessSuffix": "; {count} de excedente",
  "dashboard.metricAtSite": "{metric} de {site}",
  "dashboard.aboveTarget": "+{count} sobre la meta",
  "dashboard.pendingCount": "{count} pendientes",
  "dashboard.excessShort": "exced.",
  "dashboard.meterDescription": "{label}: {scheduled} programados de {target} de meta. {percentage}. {state}: {count}.",
  "dashboard.scheduledOf": "{scheduled} de {target} programados",
  "dashboard.monthlyTitle": "Programación mensual de {metric} · {site} · {year}",
  "dashboard.scheduledPerMonth": "{metric} por mes",
  "dashboard.targetProgress": "Meta anual: {target} · Avance: {scheduled}",
  "dashboard.analyzeMonth": "Analizar {month}",
  "dashboard.analyzeMonthlyValue": "Analizar {month}. {value}.",
  "dashboard.scheduledUnits": "{count} {metric}",
  "dashboard.recordedMonths": "{count} meses con registro",
  "dashboard.monthlyDifference": "El detalle disponible suma {total}; el avance anual registrado es {scheduled}.",
  "dashboard.nationalTableCaption": "Meta y programación mensual y acumulada de {metric}. Selecciona un mes para actualizar los indicadores.",
  "dashboard.nationalSummaryYear": "Resumen nacional · ENAPRES · {year}",
  "dashboard.nationalEmptyYear": "Sin información nacional para {year}",
  "dashboard.monthRange": "{first} a {last}",
  "dashboard.recordedOfTwelve": "{count} de 12 meses con registro",
  "dashboard.incompleteCumulative": "No hay un acumulado completo para {month}. Los meses sin registro no se consideran cero.",
  "dashboard.annualShare": "La programación acumulada a {month} representa el {percentage} de la meta anual.",
  "dashboard.nationalScopeNote": "Meta: {target} {metric} · Programación: {scheduled}. Este resumen tiene un ámbito distinto de las {count} sedes disponibles en «Por sede».",
  "dashboard.loadedAt": "Datos cargados el {date} (Lima).",
  "dashboard.warningOne": "{count} observación",
  "dashboard.warningMany": "{count} observaciones",
  "dashboard.cumulativeChartTitle": "Meta y programación acumulada de {metric} por mes",
  "dashboard.analyzeNationalMonth": "Analizar {month} en el gráfico nacional",
  "dashboard.cumulativeUnit": "{metric} · acumulado",
  "dashboard.tooltipMonth": "En el mes: meta {target} · programación {scheduled}",
  "dashboard.donutExplore": "Explorar {label}. {segment}: {percent} %. Usa las flechas para cambiar entre cobertura y pendientes.",
  "dashboard.donutValue": "{percent} %, {value} de {total}",
  "dashboard.reconciliation.match": "{description}: {actual}; coincide con el total nacional declarado.",
  "dashboard.reconciliation.difference": "{description}: {actual} frente a {expected} del total nacional declarado. Diferencia: {difference}.",
  "dashboard.reconciliation.monthlyTarget": "Suma de metas mensuales de {metric}",
  "dashboard.reconciliation.monthlyScheduled": "Suma de programación mensual informada de {metric}",
  "dashboard.reconciliation.siteTarget": "Suma de metas por sede de {metric}",
  "dashboard.reconciliation.siteScheduled": "Suma de programación por sede de {metric}",
  "dashboard.reconciliation.unknownMonths": "{count} meses tienen programación sin confirmar. No se interpretan como cero ni se prolonga el acumulado a esos meses.",
  "dashboard.reconciliation.coverageComplete": "Detalle disponible para las {expected} sedes esperadas.",
  "dashboard.reconciliation.coverageUnknown": "Hay {registered} sedes con detalle. La cobertura nacional esperada no está definida; no se comparan sus totales con el resumen nacional.",
  "dashboard.reconciliation.coveragePartial": "Cobertura parcial del detalle: {registered} de {expected} sedes. Sus totales no se comparan con el resumen nacional hasta completar la cobertura.",
  "dashboard.reconciliation.excessOne": "{count} sede supera su meta de {metric}: {excess} de excedente. No compensa pendientes de otras sedes.",
  "dashboard.reconciliation.excessMany": "{count} sedes superan su meta de {metric}: {excess} de excedente. No compensa pendientes de otras sedes.",
  "dashboard.exportStem": "segmentacion",
  "dashboard.nationalExportStem": "segmentacion-nacional",
  "dashboard.exportMonth": "mes"
};

export const en: Record<string, string> = {
  "dashboard.title": "Segmentation",
  "dashboard.pageDescription": "Scheduled dwellings and clusters by site and national monthly trends.",
  "dashboard.bySite": "By site",
  "dashboard.national": "National trends",
  "dashboard.updating": "Updating…",
  "dashboard.scope": "Segmentation scope",
  "dashboard.loadError": "The scheduling data could not be loaded.",
  "dashboard.exportError": "The scheduling data could not be exported.",
  "dashboard.updateError": "The scheduling data could not be updated",
  "dashboard.retainedData": "Data from the last query is retained.",
  "dashboard.loadingLabel": "Loading the segmentation dashboard",
  "dashboard.loading": "Loading the segmentation dashboard…",
  "dashboard.summaryLabel": "Scheduling summary for registered sites",
  "dashboard.registeredSites": "Registered sites",
  "dashboard.showAll": "Show all sites",
  "dashboard.viewExcess": "View surpluses",
  "dashboard.noExcess": "No recorded surpluses",
  "dashboard.missingMetric": "At least one metric has no monthly detail",
  "dashboard.ringNote": "The charts show target coverage by site. Total scheduling includes surpluses.",
  "dashboard.siteSchedule": "Scheduling by site",
  "dashboard.compareDescription": "Compare progress and view the monthly breakdown.",
  "dashboard.scheduleView": "Scheduling view",
  "dashboard.chart": "Chart",
  "dashboard.table": "Table",
  "dashboard.restore": "Restore view",
  "dashboard.expand": "Expand view",
  "dashboard.searchSite": "Search sites",
  "dashboard.sitePlaceholder": "Site name",
  "dashboard.clearSearch": "Clear search",
  "dashboard.status": "Status",
  "dashboard.allSites": "All sites",
  "dashboard.withPending": "With pending units",
  "dashboard.withExcess": "With surpluses",
  "dashboard.withoutMonthly": "No monthly breakdown",
  "dashboard.sortBy": "Sort by",
  "dashboard.sortSite": "Site · A to Z",
  "dashboard.sortHousingAsc": "Dwellings · least progress",
  "dashboard.sortHousingDesc": "Dwellings · most progress",
  "dashboard.sortClustersAsc": "Clusters · least progress",
  "dashboard.sortClustersDesc": "Clusters · most progress",
  "dashboard.clearFilters": "Clear filters",
  "dashboard.noSites": "No sites found",
  "dashboard.noSchedule": "No scheduling data recorded",
  "dashboard.changeFilters": "Try another name or change the status filter.",
  "dashboard.selectProgress": "Select a progress value to view monthly details.",
  "dashboard.selectValue": "Select a progress value to view details.",
  "dashboard.excessNote": "Progress above 100% indicates scheduling beyond the target. Pending units and surpluses are added by site without offsetting each other.",
  "dashboard.housing": "Dwellings",
  "dashboard.clusters": "Clusters",
  "dashboard.housingLower": "dwellings",
  "dashboard.clustersLower": "clusters",
  "dashboard.scheduledHousing": "Scheduled dwellings",
  "dashboard.scheduledClusters": "Scheduled clusters",
  "dashboard.annualBySite": "Annual scheduling by site",
  "dashboard.ofTarget": " of the target",
  "dashboard.covered": "Target covered",
  "dashboard.uncovered": "To be covered",
  "dashboard.annualTarget": "Annual target",
  "dashboard.pending": "Pending",
  "dashboard.pendingLower": "pending",
  "dashboard.pendingSingle": "Pending",
  "dashboard.excess": "Surplus",
  "dashboard.donutPending": "To be covered: {value} ({percentage}).",
  "dashboard.site": "Operational site",
  "dashboard.scheduledTarget": "Scheduled / target",
  "dashboard.scheduledTargetOther": "Scheduled / target",
  "dashboard.siteProgress": "Scheduling progress by site",
  "dashboard.noTargetDefined": "No target defined",
  "dashboard.noTarget": "No target",
  "dashboard.exceeds": "Exceeds target",
  "dashboard.viewMonths": "View months",
  "dashboard.targetUndefined": "Target not defined",
  "dashboard.siteTable": "Scheduling table by site",
  "dashboard.siteTableCaption": "Scheduled dwellings and clusters by site. Progress links open the monthly details.",
  "dashboard.target": "Target",
  "dashboard.progress": "Progress",
  "dashboard.pendingExcess": "Pending / surplus",
  "dashboard.pendingExcessShort": "Pend. / surplus",
  "dashboard.selectionSubtotal": "Selection subtotal",
  "dashboard.siteTotal": "All sites total",
  "dashboard.prioritize": "Prioritize site reviews",
  "dashboard.largestPending": "Largest annual pending totals",
  "dashboard.priorityNote": "Compare the volume still to be scheduled. These annual values alone do not indicate a delay.",
  "dashboard.sampleType": "Sample type",
  "dashboard.noPending": "There are no pending units recorded for this metric.",
  "dashboard.chartRegion": "Monthly scheduling chart; horizontal scrolling available",
  "dashboard.monthlyChartDescription": "Months with no record are not connected. Monthly values are also available in the detail table.",
  "dashboard.monthlySchedule": "Monthly scheduling",
  "dashboard.noRecordAvailable": "— No record available",
  "dashboard.chartMonths": "Chart months",
  "dashboard.noRecord": "No record",
  "dashboard.scheduledFeminine": "scheduled",
  "dashboard.scheduledMasculine": "scheduled",
  "dashboard.monthKeyboard": "Select a month to keep its details visible. Use the left and right arrows to browse months; Home and End go to the first and last.",
  "dashboard.monthlyLoadError": "Monthly details could not be loaded.",
  "dashboard.chartImageError": "The chart image could not be generated.",
  "dashboard.browserImageError": "The browser could not prepare the image.",
  "dashboard.imageError": "The image could not be generated.",
  "dashboard.chartDownloadError": "The chart could not be downloaded.",
  "dashboard.printBlocked": "Allow the print window in your browser and try again.",
  "dashboard.printSave": "Print or save as PDF",
  "dashboard.schedule": "Scheduling",
  "dashboard.missingNotZero": "Months with no available record are not interpreted as zero.",
  "dashboard.monthlyLoading": "Loading monthly details…",
  "dashboard.annualSchedule": "Annual scheduling",
  "dashboard.monthlyView": "Monthly details view",
  "dashboard.queryMonth": "Month to view",
  "dashboard.monthlyHint": "Select a point to view the month. Dashes indicate months with no record; they are not treated as zero.",
  "dashboard.recordedMonthTotal": "Total for recorded months",
  "dashboard.noMonthly": "No monthly details",
  "dashboard.noMonthlyDescription": "No monthly records are available for this site and year.",
  "dashboard.annualAvailable": "The annual summary remains available.",
  "dashboard.preparing": "Preparing…",
  "dashboard.printPdf": "Print / PDF",
  "dashboard.nationalTable": "National trends table by month; horizontal scrolling available",
  "dashboard.monthTarget": "Monthly target",
  "dashboard.monthScheduled": "Scheduled this month",
  "dashboard.cumulativeTarget": "Cumulative target",
  "dashboard.cumulativeScheduled": "Cumulative scheduled units",
  "dashboard.cumulativeGap": "Cumulative gap",
  "dashboard.annualTargetPercent": "% of annual target",
  "dashboard.nationalTableNote": "— No record available. The gap is cumulative scheduling minus the cumulative target; a negative value indicates units still to be scheduled against the plan.",
  "dashboard.nationalLoadError": "National trends could not be loaded.",
  "dashboard.nationalExportError": "National trends could not be exported.",
  "dashboard.monthlyEvolution": "Monthly trends",
  "dashboard.nationalScope": "National scope",
  "dashboard.nationalUpdateError": "The national summary could not be updated",
  "dashboard.lastQueryData": "Data from the last query is displayed.",
  "dashboard.nationalLoading": "Loading national trends…",
  "dashboard.nationalNoMonths": "No monthly records are available for this year. Select another year to view its trends.",
  "dashboard.indicator": "Indicator",
  "dashboard.nationalIndicator": "National trends indicator",
  "dashboard.analysisMonth": "Analysis month",
  "dashboard.cumulativeSchedule": "Cumulative scheduling",
  "dashboard.planGap": "Gap against plan",
  "dashboard.gapMissing": "Records are missing for this calculation",
  "dashboard.gapBelow": "Still to be scheduled against the cumulative plan",
  "dashboard.gapAbove": "Above the cumulative plan",
  "dashboard.gapReached": "Cumulative plan reached",
  "dashboard.nationalView": "National trends view",
  "dashboard.allTwelve": "The chart and table show all 12 months.",
  "dashboard.nationalAnnual": "Recorded national annual summary",
  "dashboard.reconciliation": "Data reconciliation",
  "dashboard.viewChecks": "View checks",
  "dashboard.yearProgress": "Cumulative progress during the year",
  "dashboard.legend": "Chart legend",
  "dashboard.nationalChart": "Interactive national trends chart",
  "dashboard.nationalChartDescription": "The dashed line shows the plan and the solid line shows scheduling. Use the left and right arrows to explore months; Enter or Space selects the analysis month. Escape closes the details. Months with no data interrupt the series.",
  "dashboard.inAnalysis": "Selected for analysis",
  "dashboard.preview": "Preview",
  "dashboard.gap": "Gap",
  "dashboard.selectAnalysis": "Select this month to update the analysis.",
  "dashboard.swipeMonths": "Scroll the chart horizontally to view all months.",
  "dashboard.nationalKeyboard": "Select a month in the chart to analyze it. Keyboard: ← → to explore and Enter to select.",
  "dashboard.zeroNote": "The line retains the cumulative total when a month records zero and breaks when information is missing.",
  "dashboard.noTargetLower": "no target defined",
  "dashboard.coverageNote": "Coverage without offsetting surpluses",
  "dashboard.pendingSite": "Pending scheduling by site",
  "dashboard.operationalYear": "operational sites · {year}",
  "dashboard.siteExceedsOne": "{count} site exceeds its target",
  "dashboard.siteExceedsMany": "{count} sites exceed their targets",
  "dashboard.missingBreakdown": "{count} sites with a pending breakdown",
  "dashboard.dataLoaded": "Data loaded: {date}",
  "dashboard.siteRange": "{count} of {total} sites",
  "dashboard.noScheduleYear": "No scheduling records are available for {year}.",
  "dashboard.registeredOne": "{count} registered site",
  "dashboard.registeredMany": "{count} registered sites",
  "dashboard.coveredBySite": "{metric} target covered by site",
  "dashboard.exploreCoverage": "Explore {metric} coverage",
  "dashboard.detailLabel": "View monthly {metric} details for {site}. {scheduled} scheduled against a target of {target}; {percentage}; {pending} pending{excess}.",
  "dashboard.excessSuffix": "; {count} surplus",
  "dashboard.metricAtSite": "{metric} at {site}",
  "dashboard.aboveTarget": "+{count} above target",
  "dashboard.pendingCount": "{count} pending",
  "dashboard.excessShort": "surplus",
  "dashboard.meterDescription": "{label}: {scheduled} scheduled against a target of {target}. {percentage}. {state}: {count}.",
  "dashboard.scheduledOf": "{scheduled} of {target} scheduled",
  "dashboard.monthlyTitle": "Monthly {metric} scheduling · {site} · {year}",
  "dashboard.scheduledPerMonth": "{metric} per month",
  "dashboard.targetProgress": "Annual target: {target} · Progress: {scheduled}",
  "dashboard.analyzeMonth": "Analyze {month}",
  "dashboard.analyzeMonthlyValue": "Analyze {month}. {value}.",
  "dashboard.scheduledUnits": "{count} {metric}",
  "dashboard.recordedMonths": "{count} months with records",
  "dashboard.monthlyDifference": "The available details total {total}; recorded annual progress is {scheduled}.",
  "dashboard.nationalTableCaption": "Monthly and cumulative targets and scheduling for {metric}. Select a month to update the indicators.",
  "dashboard.nationalSummaryYear": "National summary · ENAPRES · {year}",
  "dashboard.nationalEmptyYear": "No national data for {year}",
  "dashboard.monthRange": "{first} to {last}",
  "dashboard.recordedOfTwelve": "{count} of 12 months with records",
  "dashboard.incompleteCumulative": "There is no complete cumulative total for {month}. Months with no record are not treated as zero.",
  "dashboard.annualShare": "Cumulative scheduling through {month} represents {percentage} of the annual target.",
  "dashboard.nationalScopeNote": "Target: {target} {metric} · Scheduled: {scheduled}. This summary covers a different scope from the {count} sites available under “By site”.",
  "dashboard.loadedAt": "Data loaded on {date} (Lima).",
  "dashboard.warningOne": "{count} observation",
  "dashboard.warningMany": "{count} observations",
  "dashboard.cumulativeChartTitle": "Cumulative target and scheduling for {metric} by month",
  "dashboard.analyzeNationalMonth": "Analyze {month} in the national chart",
  "dashboard.cumulativeUnit": "{metric} · cumulative",
  "dashboard.tooltipMonth": "This month: target {target} · scheduled {scheduled}",
  "dashboard.donutExplore": "Explore {label}. {segment}: {percent}%. Use the arrow keys to switch between coverage and pending units.",
  "dashboard.donutValue": "{percent}%, {value} of {total}",
  "dashboard.reconciliation.match": "{description}: {actual}; matches the declared national total.",
  "dashboard.reconciliation.difference": "{description}: {actual} versus {expected} in the declared national total. Difference: {difference}.",
  "dashboard.reconciliation.monthlyTarget": "Sum of monthly targets for {metric}",
  "dashboard.reconciliation.monthlyScheduled": "Sum of reported monthly scheduling for {metric}",
  "dashboard.reconciliation.siteTarget": "Sum of site targets for {metric}",
  "dashboard.reconciliation.siteScheduled": "Sum of site scheduling for {metric}",
  "dashboard.reconciliation.unknownMonths": "{count} months have unconfirmed scheduling. These are not interpreted as zero and cumulative totals are not extended into those months.",
  "dashboard.reconciliation.coverageComplete": "Details are available for all {expected} expected sites.",
  "dashboard.reconciliation.coverageUnknown": "Details are available for {registered} sites. Expected national coverage is undefined; their totals are not compared with the national summary.",
  "dashboard.reconciliation.coveragePartial": "Partial detail coverage: {registered} of {expected} sites. Their totals are not compared with the national summary until coverage is complete.",
  "dashboard.reconciliation.excessOne": "{count} site exceeds its {metric} target: {excess} surplus units. This does not offset pending units at other sites.",
  "dashboard.reconciliation.excessMany": "{count} sites exceed their {metric} targets: {excess} surplus units. This does not offset pending units at other sites.",
  "dashboard.exportStem": "segmentation",
  "dashboard.nationalExportStem": "national-segmentation",
  "dashboard.exportMonth": "month"
};
